export default __webpack_public_path__ + "images/BI.4fd59f2.png";